const FormikField = {
  sickName: {
    color: '#753cbe',

    fontSize: '14px',
    fontWeight: 'bold',
    margin: 0,
  },
  label: {
    color: '#707070',

    fontSize: '14x',
    fontWeight: 'bold',
  },
  labelMeal: {
    color: '#a0a0a0',

    fontSize: '12px !important',
    fontWeight: '600',
  },
  MealBtn: {
    display: 'flex !important',
    justifyContent: 'center !important',
    alignItems: 'center !important',
    cursor: 'pointer ',
    height: '32px !important',
    margin: '0 10px !important',
    borderRadius: '16px !important',
    border: 'solid 1px #d8d8d8 !important',
    fontSize: '12px !important',

    backgroundColor: '#f5f5f5 !important',
  },
  markerStyle: {
    top: '12px',
    left: '45px',
    position: 'absolute',
    fontSize: '14px',
    color: '#707070',
  },
  parentTextField: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'left',
    alignItems: 'center',
  },
  textfied: {
    '& .MuiFormHelperText-root': {
      textAlign: 'left !important',
    },
    input: {
      '&::placeholder': {
        opacity: '1',
        fontSize: '14px',
        color: 'rgba(112, 112, 112, 1)',
      },
    },
    '& .MuiOutlinedInput-root': {
      boxShadow:
        '-5px 5px 10px 0px rgba(174, 174, 192, 0.2),4px -4px 15px 0px rgba(255, 255, 255, 1)',
      fontSize: '0.875rem',
      color: '#753CBE',
      fontWeight: '700',
      marginLeft: 'auto',
      height: '48px',
      borderRadius: '16px',
      border: '1px solid #FFFFFF',
      '& > fieldset': {
        border: 'none !important',
        height: '48px',
      },
    },
  },
  textFieldMarker: {
    position: 'absolute',
    margin: 'auto',
    width: '155px',
    marginLeft: '20px',
    fontSize: '14px',
    color: 'rgba(112, 112, 112, 1)',
  },
  '&.MuiFormHelperText-roo': {
    textAlign: 'right !important',
  },
  errorText: {
    color: 'var(--red)',
    fontSize: '12px',
    fontWeight: 'bold',
    marginTop: '6px',
    marginLeft: '8px',
  },
};

export default FormikField;
